/**
 * Typed ops EFEM peripherals health API facade over the generated contract client.
 */

import { opsEfemPeripheralsApi } from '../api/generated/opsEfemPeripherals.api.js';
import {
  type EfemPeripheralHealthListQuery,
  type EfemPeripheralHealthListResponse,
} from '@cnapse/shared/schemas.js';

class OpsEfemPeripheralsService {
  async getEfemPeripheralHealthList(
    query: EfemPeripheralHealthListQuery,
  ): Promise<EfemPeripheralHealthListResponse> {
    return opsEfemPeripheralsApi.list(query) as Promise<EfemPeripheralHealthListResponse>;
  }
}

export const opsEfemPeripheralsService = new OpsEfemPeripheralsService();
